<div class="card mb-md-0 mb-3 pointer"  [routerLink]="'/crowdfunding/projects/' + project?.seotag">
  <div class="position-relative">
    <span class="status position-absolute" [ngClass]="project?.status">
      {{
      'STATUS.' + project?.status | translate
      }}</span>

    <div class="image" [style.width]="
        calcPercentage(project?.commitedTokens ?? 0, project?.totalTokens ?? 0)+'%'">
      <img src="assets/images/crowdfunding/crowd.png" [alt]="'Imagen de' + project?.name" />
    </div>
    <div class="image-grey">
      <img src="assets/images/crowdfunding/crowd.png" [alt]="'Imagen de' + project?.name" />
    </div>
  </div>
  <div class="over position-relative">
    <div class="progress-porcentage" [style.width]="
        calcPercentage(project?.commitedTokens ?? 0, project?.totalTokens ?? 0)+'%'
      "></div>
    <div class="progress"></div>
  </div>
  <div class="d-flex grey border">
    <div class="col-4 ps-3 py-1">
      <div class="text f-bold">{{'SHARED.CARD.CURRENT' | translate}}</div>
      <div class="number"> <span class="small">{{project?.currency}}</span> {{ roundNumber(project?.commitedTokens) }}
      </div>
    </div>
    <div class="col-4 border-end border-start py-1 text-center">
      <div class="text">{{'SHARED.CARD.PROGRESS' | translate}}</div>
      <div class="number">
        {{
        calcPercentage(
        project?.commitedTokens ?? 0,
        project?.totalTokens ?? 0
        )
        }}%
      </div>
    </div>
    <div class="col-4 pe-3 py-1 text-end">
      <div class="text">{{'SHARED.CARD.OBJETIVE' | translate}}</div>
      <div class="number"> <span class="small">{{project?.currency}}</span> {{ project?.totalTokens }}</div>
    </div>
  </div>
  <div class="p-3">
    <div class="name mb-1 text-truncate">{{ project?.name }}</div>
    <div class="description mb-1">
      {{ project?.description }}
    </div>
    <div class="place">{{ project?.locality }} {{ project?.province ? (','+ project?.province) : '' }}</div>
  </div>
  <div class="bottoms">
    <div class="border-bottom border-top">
      <div class="row">
        <div class="col-12 text-center py-2">
          <div class="text text-uppercase">{{project?.currency ?? 'USD' ? 'Rentabilidad estimada' : 'Rentabilidad'}}
          </div>
          <div class="percentage">{{project?.tir}}%</div>
        </div>
      </div>
      <div class="d-flex justify-content-between px-3 py-2 border-top">
        <div class="text text-uppercase">{{'SHARED.CARD.MIN_INVEST' | translate}}</div>
        <div class="number"><span
          class="small">{{project?.currency}}</span> {{ project ? project.lastTradePrice * project.minimumTokens : '' }} 
        </div>
      </div>
      <div class="d-flex justify-content-between px-3 py-2 border-top">
        <div class="text text-uppercase">{{'SHARED.CARD.PERIOD' | translate}}</div>
        <div class="number">{{formmatedDate(project?.start ?? '-') }} -
          {{ formmatedDate(project?.finish ?? '-') }} </div>
      </div>
    </div>
  </div>
  <div class="p-3">
    <button class="w-100" [ngClass]="project?.status == 'FUNDING' ? 'primary ' : 'outline'">
      {{project?.status == 'FUNDING' ? ('SHARED.CARD.INVEST' | translate) : ('PLATFORM.MOVEMENTS.SEE_PROJECT' |
      translate)}}
    </button>
  </div>
</div>